import { checkTablesInDB, safeTransaction } from "../../helpers/db";

export const insertTakeDetailsInDB = async (data) => {
  try {
    const tables = ["takedDetails", "addedTakeDetails"];
    checkTablesInDB(tables);
    let addedDataID = "";
    await safeTransaction(tables, async (tx) => {
      const takedDetailsTable = tx.table(tables[0]);
      const addedTakeDetailsTable = tx.table(tables[1]);
      addedDataID = await takedDetailsTable.add(data);
      await addedTakeDetailsTable.add({ ...data, id: addedDataID });
    });
    return addedDataID;
  } catch (error) {
    throw error;
  }
};
